import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { PageNavigation } from "./SearchResultList";
import CustomTablePagination from "./CustomTablePagination";

export interface PageNavigationProps extends PageNavigation {}

const SearchPageNavigation = ({
  resTotal,
  skip,
  limit,
  pageNavigationHandle,
  rowsPerPageHandle,
}: PageNavigationProps) => {
  const rowsPerPageChangeHandle = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      console.log("rowsPerPageChangeHandle", ev.target.value);
      if (rowsPerPageHandle) {
        rowsPerPageHandle(+ev.target.value);
      }
    },
    []
  );

  useEffect(() => {
    console.log("limit", limit);
  }, [limit]);

  const page: number = Math.trunc(skip / limit);
  const pageChangeHandle = (
    ev: React.MouseEvent<HTMLButtonElement> | null,
    pageNum: number
  ) => {
    console.log("onPageChange", pageNum);
    pageNavigationHandle(pageNum);
  };
  return (
    <DivNav>
      {resTotal > 0 && (
        <table>
          <tbody>
            <tr>
              <CustomTablePagination
                count={resTotal}
                page={page}
                rowsPerPage={limit}
                onRowsPerPageChange={rowsPerPageChangeHandle}
                onPageChange={pageChangeHandle}
              />
            </tr>
          </tbody>
        </table>
      )}
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-bottom: 1rem;
`;

export default SearchPageNavigation;
